export const regions = [
  {
    id: "abruzzo",
    nome: "Abruzzo",
    latitudine: 42.354008,
    longitudine: 13.391992,
  },
  {
    id: "basilicata",
    nome: "Basilicata",
    latitudine: 40.633333,
    longitudine: 15.8,
  },
  {
    id: "calabria",
    nome: "Calabria",
    latitudine: 38.91,
    longitudine: 16.5875,
  },
  {
    id: "campania",
    nome: "Campania",
    latitudine: 40.833333,
    longitudine: 14.25,
  },
  {
    id: "emiliaromagna",
    nome: "Emilia-Romagna",
    latitudine: 44.493889,
    longitudine: 11.342778,
  },
  {
    id: "fvg",
    nome: "Friuli-Venezia Giulia",
    latitudine: 45.636111,
    longitudine: 13.804167,
  },
  {
    id: "lazio",
    nome: "Lazio",
    latitudine: 41.893056,
    longitudine: 12.482778,
  },
  {
    id: "liguria",
    nome: "Liguria",
    latitudine: 44.411156,
    longitudine: 8.932661,
  },
  {
    id: "lombardia",
    nome: "Lombardia",
    latitudine: 45.464161,
    longitudine: 9.190336,
  },
  {
    id: "marche",
    nome: "Marche",
    latitudine: 43.616667,
    longitudine: 13.516667,
  },
  {
    id: "molise",
    nome: "Molise",
    latitudine: 41.561,
    longitudine: 14.6684,
  },
  {
    id: "piemonte",
    nome: "Piemonte",
    latitudine: 45.066667,
    longitudine: 7.7,
  },
  {
    id: "puglia",
    nome: "Puglia",
    latitudine: 41.125278,
    longitudine: 16.866667,
  },
  {
    id: "sardegna",
    nome: "Sardegna",
    latitudine: 39.216667,
    longitudine: 9.116667,
  },
  {
    id: "sicilia",
    nome: "Sicilia",
    latitudine: 38.115556,
    longitudine: 13.361389,
  },
  {
    id: "toscana",
    nome: "Toscana",
    latitudine: 43.771389,
    longitudine: 11.254167,
  },
  {
    id: "trentino",
    nome: "Trentino-Alto Adige",
    latitudine: 46.066667,
    longitudine: 11.116667,
  },
  {
    id: "umbria",
    nome: "Umbria",
    latitudine: 43.1121,
    longitudine: 12.3888,
  },
  {
    id: "valledaosta",
    nome: "Valle d'Aosta",
    latitudine: 45.737222,
    longitudine: 7.320556,
  },
  {
    id: "veneto",
    nome: "Veneto",
    latitudine: 45.439722,
    longitudine: 12.331944,
  },
];
